// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import utils from "./utils/utils"
import i18n from './i18n'
import 'amfe-flexible'
import './common/less/reset.less'
import './common/less/base.less'
import './common/less/flex.less'
import { Toast, Lazyload, NavBar } from 'vant'
import 'vant/lib/index.less'
import dayjs from 'dayjs';
import './filters' // 引入过滤器
Vue.config.productionTip = false
Vue.prototype.$utils = utils
Vue.prototype.$dayjs = dayjs
Vue.prototype.$toast = Toast
Vue.use(Lazyload);
Vue.use(NavBar);

// 开发环境仅在显式请求时加载，避免调试悬浮窗遮挡移动端视觉验收。
const enableVConsole = /(?:^|[?&])vconsole=1(?:&|$)/.test(window.location.search)
if (process.env.NODE_ENV === 'development' && enableVConsole) {
  const VConsole = require('vconsole')
  new VConsole()
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  // template: '<App/>',
  render: h => h('App', '')
})
